import React from "react";

function MarkdownText({ text }) {
  if (!text) return null;

  const regex =
    /\[([^\]]+)\]\((https?:\/\/[^)]+)\)|(https?:\/\/[^\s]+)/g;

  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(
        <React.Fragment key={`text-${lastIndex}`}>
          {text.slice(lastIndex, match.index)}
        </React.Fragment>
      );
    }

    // Markdown link
    if (match[1] && match[2]) {
      parts.push(
        <a
          key={`link-${match.index}`}
          href={match[2]}
          target="_blank"
          rel="noopener noreferrer"
          className="faq-link"
        >
          {match[1]}
        </a>
      );
    }

    // Plain URL
    else if (match[3]) {
      parts.push(
        <a
          key={`url-${match.index}`}
          href={match[3]}
          target="_blank"
          rel="noopener noreferrer"
          className="faq-link"
        >
          {match[3]}
        </a>
      );
    }

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(
      <React.Fragment key={`text-${lastIndex}`}>
        {text.slice(lastIndex)}
      </React.Fragment>
    );
  }

  return <>{parts}</>;
}

export default MarkdownText;